import type { ReactNode } from "react";

/** 骨架/加载态用同底色的脉冲块，不要白屏（规范 §5.5）。 */
export function LoadingState({ label = "正在加载…" }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" className="space-y-3" aria-label={label}>
      <p className="dp-label">{label}</p>
      <div className="dp-skel" aria-hidden="true">
        <div className="dp-skel-block" style={{ width: 92, height: 148 }} />
        <div className="flex-1 space-y-2">
          <div className="dp-skel-block" style={{ height: 12, width: "42%" }} />
          <div className="dp-skel-block" style={{ height: 12, width: "80%" }} />
          <div className="dp-skel-block" style={{ height: 12, width: "64%" }} />
          <div className="dp-skel-block" style={{ height: 12, width: "30%" }} />
        </div>
      </div>
      <div className="dp-skel" aria-hidden="true">
        <div className="dp-skel-block" style={{ width: 92, height: 148 }} />
        <div className="flex-1 space-y-2">
          <div className="dp-skel-block" style={{ height: 12, width: "36%" }} />
          <div className="dp-skel-block" style={{ height: 12, width: "72%" }} />
          <div className="dp-skel-block" style={{ height: 12, width: "48%" }} />
        </div>
      </div>
    </div>
  );
}

export function ErrorState({
  title = "加载失败",
  message,
  onRetry,
  retryLabel = "重试",
}: {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  return (
    <div role="alert" className="dp-empty" style={{ borderColor: "rgba(223,122,102,.35)" }}>
      <span className="dp-empty-mark" aria-hidden="true" style={{ color: "var(--red)" }}>
        ⚠
      </span>
      <h2 style={{ color: "var(--red)" }}>{title}</h2>
      <p>{message}</p>
      {onRetry ? (
        <p className="mt-3">
          <button type="button" onClick={onRetry} className="dp-btn">
            {retryLabel}
          </button>
        </p>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="dp-empty">
      <span className="dp-empty-mark" aria-hidden="true">
        ✦
      </span>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
